import type { Attachment } from 'shiftNotes/_types';

const VIDEO_EXTENSIONS =
  /\.(mp4|mov|webm|m4v|ogg|ogv|3gp|3gpp|quicktime)(\?|$)/i;

export default function isVideoAttachment(attachment: Attachment): boolean {
  if (attachment.mime_type?.startsWith('video/')) return true;
  return VIDEO_EXTENSIONS.test(attachment.file);
}
